import React, { useEffect } from 'react';

import { Box } from '@rbilabs/universal-components';

import { ILocation } from '@rbi-ctg/frontend';
import useMap from 'hooks/use-map';
import { CenterPoint, MarkerTypes } from 'hooks/use-map/types';
import { useGeolocation } from 'state/geolocation';
import noop from 'utils/noop';

interface IStaticMap {
  initialZoomAndroid?: number;
  initialZoomIOS?: number;
  position: ILocation;
  title?: string;
  enablePointerEvents?: boolean;
  markerType?: MarkerTypes;
  showUserMarker?: boolean;
}

/**
 * @deprecated - use StoreLocationMap instead.
 * This component will be removed in a future version.
 */
const StaticMap: React.FC<React.PropsWithChildren<IStaticMap>> = ({
  initialZoomAndroid,
  initialZoomIOS,
  position,
  title,
  enablePointerEvents = false,
  markerType,
  showUserMarker = false,
}) => {
  const { isPermissionGranted, userCoordinates } = useGeolocation();
  const { map, createMarker } = useMap({
    initialZoomAndroid,
    initialZoomIOS,
    position: position as CenterPoint,
    isStaticMap: true,
  });

  useEffect(() => {
    // TODO: RN - Define type for location-pin-active.png
    createMarker({
      id: 'store',
      type: markerType ?? MarkerTypes.StoreOpenSelected,
      location: position as CenterPoint,
      onPress: noop,
      title,
    });
    if (isPermissionGranted && userCoordinates && showUserMarker) {
      createMarker({
        id: 'user',
        type: MarkerTypes.User,
        location: userCoordinates as CenterPoint,
        onPress: noop,
        title,
      });
    }
  }, [
    createMarker,
    isPermissionGranted,
    userCoordinates,
    markerType,
    position,
    title,
    showUserMarker,
  ]);

  return (
    <Box flex="1" pointerEvents={enablePointerEvents ? 'auto' : 'none'}>
      {map}
    </Box>
  );
};

export default StaticMap;
